var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1350 2560 l0 -2220 190 0 190 0 0 345 0 345 830 0 830 0 0 -345 0 -345 190 0 190 0 0 2220 0 2220 -1210 0 -1210 0 0 -2220z m1360 1690 l0 -180 180 0 180 0 0 -150 0 -150 -180 0 -180 0 0 -180 0 -180 -150 0 -150 0 0 180 0 180 -180 0 -180 0 0 150 0 150 180 0 180 0 0 180 0 180 150 0 150 0 0 -180z m-660 -1340 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z m680 0 l0 -150 -170 0 -170 0 0 150 0 150 170 0 170 0 0 -150z m670 0 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z m-1350 -680 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z m680 0 l0 -150 -170 0 -170 0 0 150 0 150 170 0 170 0 0 -150z m670 0 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z m-1350 -670 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z m680 0 l0 -150 -170 0 -170 0 0 150 0 150 170 0 170 0 0 -150z m670 0 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1885 l0 -1545 525 0 525 0 0 1545 0 1545 -525 0 -525 0 0 -1545z m690 1025 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z m0 -680 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z m0 -670 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070 1885 l0 -1545 525 0 525 0 0 1545 0 1545 -525 0 -525 0 0 -1545z m690 1025 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z m0 -680 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z m0 -670 l0 -150 -165 0 -165 0 0 150 0 150 165 0 165 0 0 -150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 535 l0 -195 190 0 190 0 0 195 0 195 -190 0 -190 0 0 -195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2710 535 l0 -195 190 0 190 0 0 195 0 195 -190 0 -190 0 0 -195z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.47e68e3e50311df3edd082c9e29bfb22.svg";
export { ForwardRef as ReactComponent };